module.exports = __webpack_public_path__ + "static/media/BrisColorClock.c37deefa.png";